var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('secondary-nav-bar',{staticClass:"secondary-nav-section-module",attrs:{"menu-items":_vm.menuItems}})}
var staticRenderFns = []

export { render, staticRenderFns }